import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { PlayerAvatar } from './PlayerAvatar';

type RollingCaptainsProps = {
  allCaptains: string[];
  ignoredCaptains: string[];
  chosenCaptain?: string;
  startRolling?: boolean;
};

export const RollingCaptains = ({
  allCaptains,
  ignoredCaptains,
  chosenCaptain,
  startRolling,
}: RollingCaptainsProps) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    let handler: any;

    if (!startRolling) {
      if (handler) {
        clearInterval(handler);
      }
      return;
    }

    handler = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        let nextIndex = prevIndex + 1;
        if (nextIndex >= allCaptains.length) {
          nextIndex = 0;
        }
        return nextIndex;
      });
    }, 100);

    return () => clearTimeout(handler);
  }, [allCaptains, ignoredCaptains, chosenCaptain, startRolling]);

  return (
    <Stack direction="row" spacing={4} sx={{ mt: 4 }} alignItems="flex-start">
      {allCaptains.map((captain) => (
        <Stack direction="column" key={captain} alignItems="center">
          {(captain === allCaptains[currentIndex] && startRolling) ||
          captain === chosenCaptain ? (
            <SportsSoccerIcon sx={{ fontSize: 40, color: '#d50000' }} />
          ) : (
            <PlayerAvatar name={captain} bgColor="gray" />
          )}
          <Typography>{captain}</Typography>
          {ignoredCaptains.includes(captain) && (
            <CheckCircleIcon
              sx={{ color: captain === chosenCaptain ? '#2e7d32' : 'gray' }}
            />
          )}
        </Stack>
      ))}
    </Stack>
  );
};
